export function OutlineSearchPlusIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2349 13.3794C16.7799 12.381 17.0838 11.2428 17.0838 10.0322C17.0838 6.14952 13.9343 3 10.0516 3C6.16899 3 3.01465 6.14952 3.01465 10.0322C3.01465 13.9148 6.16417 17.0691 10.0516 17.0691C11.2622 17.0691 12.4005 16.7653 13.3989 16.2251L18.1738 21L21.0146 18.1592L16.2349 13.3794Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0515 7.01758V13.0465"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.03711 10.0312H13.066"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
